const PropTypes = require("prop-types");
const {Provider} = require("mobx-react");
const React = require("react");
const shortid = require("shortid");
const {decodeObservable} = require("helpers/object");

class BaseProvider extends React.Component {

    constructor(props) {
        super(props);

        this.provider_uuid = shortid.generate();
        this.state = {uuid: shortid.generate()};

    }

    updateUuid() {
        if(this.props.frozen !== true) {
            //console.log('Provider not frozen, updating', this);
            this.setState({uuid: shortid.generate()});
        } else {
            //console.log('Provider frozen, dont update', this);
        }
    }

    /////////////////////////////////
    // Statics
    /////////////////////////////////

    static get propTypes() {
        return {};
    }

    static get defaultProps() {
        return {};
    }

    /////////////////////////////////
    // Helpers
    /////////////////////////////////

    get providerProps() {
        return {};
    }

    /////////////////////////////////
    // Renderers
    /////////////////////////////////

    render() {//new Error('provider props test'),
        //console.log( this.provider_uuid, this.providerProps);
        return (
            <Provider key={this.state.uuid} {...this.providerProps} >
                <React.Fragment >
                    {this.props.children}
                </React.Fragment >
            </Provider >
        );
    }

}

module.exports = BaseProvider;